var map = {
	"./1/symbol_0.png": 75014,
	"./1/symbol_1.png": 43759,
	"./1/symbol_10.png": 13759,
	"./1/symbol_11.png": 35670,
	"./1/symbol_12.png": 26349,
	"./1/symbol_2.png": 21300,
	"./1/symbol_3.png": 58781,
	"./1/symbol_4.png": 49634,
	"./1/symbol_5.png": 13291,
	"./1/symbol_6.png": 47888,
	"./1/symbol_7.png": 63641,
	"./1/symbol_8.png": 48078,
	"./1/symbol_9.png": 21719,
	"./2/symbol_0.png": 3375,
	"./2/symbol_1.png": 38182,
	"./2/symbol_10.png": 55348,
	"./2/symbol_11.png": 76477,
	"./2/symbol_12.png": 9062,
	"./2/symbol_2.png": 19389,
	"./2/symbol_3.png": 98260,
	"./2/symbol_4.png": 48171,
	"./2/symbol_5.png": 57666,
	"./2/symbol_6.png": 40601,
	"./2/symbol_7.png": 34352,
	"./2/symbol_8.png": 50711,
	"./2/symbol_9.png": 51214,
	"./3/symbol_0.png": 93468,
	"./3/symbol_1.png": 10981,
	"./3/symbol_10.png": 54593,
	"./3/symbol_12.png": 56371,
	"./3/symbol_2.png": 92206,
	"./3/symbol_3.png": 82199,
	"./3/symbol_4.png": 2584,
	"./3/symbol_5.png": 75297,
	"./3/symbol_6.png": 26314,
	"./3/symbol_7.png": 77075,
	"./3/symbol_8.png": 81780,
	"./3/symbol_9.png": 2909,
	"./4/symbol_0.png": 7645,
	"./4/symbol_1.png": 90964,
	"./4/symbol_10.png": 41422,
	"./4/symbol_12.png": 28892,
	"./4/symbol_2.png": 65455,
	"./4/symbol_3.png": 26438,
	"./4/symbol_4.png": 59481,
	"./4/symbol_5.png": 53232,
	"./4/symbol_6.png": 40875,
	"./4/symbol_7.png": 19746,
	"./4/symbol_8.png": 20306,
	"./4/symbol_9.png": 15036
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47310;